import { render, staticRenderFns } from "./Visitor.vue?vue&type=template&id=0820f9f4&scoped=true&"
import script from "./Visitor.vue?vue&type=script&lang=js&"
export * from "./Visitor.vue?vue&type=script&lang=js&"
import style0 from "./Visitor.vue?vue&type=style&index=0&id=0820f9f4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0820f9f4",
  null
  
)

export default component.exports